import React from "react";
import {OWN_LOAN_STATUS_LIST} from "./ownLoanConstants";
import {SelectField, TextArea} from "../../../../Components/Inputs";
import {convertCamelCaseToSpaceDelimited} from "../../../../Utilities/commonUtilities";
import {HtmlDisplay} from "../../../../Components/Display";
import {PATRON_SUBTYPE_LIST} from "../../../../Components/Authorize/roleConstants";
import {OwnLoanItem} from "./ownLoan.types";
import type {ListItem} from "../../../../Utilities/Types/listUtilities";

interface OwnLoanEditFormViewProps {
    ownLoanItemForDialog: OwnLoanItem;
    setOwnLoanItemForDialog: (item: OwnLoanItem) => void;
}

export const OwnLoanEditFormView = ({
                                        ownLoanItemForDialog,
                                        setOwnLoanItemForDialog
                                    }: OwnLoanEditFormViewProps) => {

    const handleOwnLoanStatusChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setOwnLoanItemForDialog({...ownLoanItemForDialog, ownLoanStatus: event.target.value});
    }

    const handleOwnLoanNotesChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        setOwnLoanItemForDialog({...ownLoanItemForDialog, ownLoanNotes: event.target.value});
    }

    return <>
        {
            ownLoanItemForDialog.patronSubType &&
            <HtmlDisplay
                html={`Patron Role: ${PATRON_SUBTYPE_LIST.find((f: ListItem) => f.value === ownLoanItemForDialog.patronSubType)?.text || ``}`}
                name={`patron-subtype-${ownLoanItemForDialog.ownLoanItemId}`}
            />
        }
        {
            ownLoanItemForDialog.patronEmail &&
            <HtmlDisplay
                html={`Patron email: ${ownLoanItemForDialog.patronEmail}`}
                name={`patron-email-${ownLoanItemForDialog.ownLoanItemId}`}
            />
        }
        <hr/>

        <SelectField
            includeDefaultOption={false}
            label={convertCamelCaseToSpaceDelimited("OwnStatus", true)}
            name={"OwnLoanStatus"}
            onChange={handleOwnLoanStatusChange}
            options={OWN_LOAN_STATUS_LIST}
            value={ownLoanItemForDialog.ownLoanStatus}
        />

        <TextArea
            label={"Own Notes"}
            name={"ownLoanNotes"}
            onChange={handleOwnLoanNotesChange}
            value={ownLoanItemForDialog.ownLoanNotes}
        />
    </>;
};
